import React, { useState } from "react";
import { CustomIcon } from "../../../components/Icons";
import classNames from "classnames";
import { getProfileURL } from "../../../utils/profile-url";
import { Link } from "react-router-dom";
import { arenaModes } from "../../data/modes";
import moment from "moment";
import { BattlePlayerInfo, BattleRecord } from "../../types";
import Button from "../../../components/Button";
import useWindowSize from "../../../hooks/useWindowSize";
import IconButton from "../../../components/IconButton";
import {motion} from "framer-motion";
import { useAppTranslation } from "../../../i18n/useAppTranslation";
type Props = {
  match: BattleRecord;
};

const LiveBattleRecord = ({ match }: Props) => {

  const [isExpanded, setIsExpanded] = useState(false);
  const { t } = useAppTranslation("battle");

  const { width } = useWindowSize();

  if (width < 768) {
    return (
      <div className="battle-record-mobile position-relative">
        {/* <CardBg  style={{position:'absolute',top:0,left:0,height:cardHeight}} /> */}
        <div className="d-flex position-relative flex-column gap-1">
          <div className="d-flex  justify-content-start gap-1 flex-row  align-items-center">
          <PlayerAvatar {...match.attackerPlayers[0]} />
            <div className="d-flex flex-column align-items-center">
              <img
                src="/assets/images/icons/blades.png"
                width={30}
                height={30}
              />
              <span className="fs-tiny dark-yellow">
                {moment(match.startTime).fromNow()}
              </span>
            </div>
<PlayerAvatar {...match.defenderPlayers[0]} />
            <Link
              to={"/arena/live?replayId=" + match.battleId}
              className="ms-auto me-1"
            >
              <IconButton
                style={{ width: 33, height: 33 }}
                icon={<img width={10} src="/assets/images/icons/play.svg" />}
              />
            </Link>
          </div>
          <div className="d-flex gap-2 flex-row align-items-center justify-content-start">
            <div className="fs-med d-flex align-items-center ">
              <CustomIcon
                className="fs-med"
                icon="timer"
                width={18}
                height={18}
              />
              {moment(match.startTime).format("DD/MM/YYYY")}
           
            </div>
            <div className="dark-yellow gap-1 d-flex align-items-center">
              <CustomIcon icon="shield-blade" width={18} height={18} />
              <span className="fs-med dark-yellow">
                {/* {arenaModes[match.]} */}
              </span>
            </div>
          </div>

        </div>
      </div>
    );
  }

  return (
    <div className="row justify-content-between battle-record  p-3  rounded bg-2 ">
      <div className="d-flex col-4  col-lg-4 justify-content-center flex-row gap-3 align-items-center">
        <PlayerAvatar {...match.attackerPlayers[0]} />
        <div className="d-flex flex-column align-items-center">
          <img src="/assets/images/icons/blades.png" width={30} height={30} />
        </div>
        <PlayerAvatar {...match.defenderPlayers[0]} />
      </div>
      <div className="d-flex col-4  col-lg-3 gap-1 flex-row align-items-center justify-content-center">
        <CustomIcon icon="eye" width={18} height={14} />
        {match.watchers}
      </div>
      <div className="d-flex col-6  col-lg-3 flex-column align-items-center justify-content-center">
        <div className="fs-big ">
          {moment(new Date(match.startTime||0)).format("HH:mm")}
        </div>
        <div className="dark-yellow gap-1 d-flex align-items-center">

        {/* TODO: Add icons */}
        {/* <img src={arenaModesIcons[match.adventureMode]} width={18} height={18} /> */}
          <span className="fs-med dark-yellow">
            {/* {arenaModes[match.adventureMode]} */}
          </span>
        </div>
      </div>
      <div className="d-flex col-6 col-lg-2  flex-column justify-content-center align-items-center">
        <Link to={"/arena/live?watchId=" + match.battleId}>
          <Button variant="primary" className="bg-100 gap-2">
            <CustomIcon
              width={10}
              icon="play"
              type="svg"
              className="opacity-50"
            />
            {t("watch.title")}
          </Button>
        </Link>
      </div>
    </div>
  );
};

const PlayerAvatar = (player: BattlePlayerInfo) => (
  <Link
    to={"/profile/" + player.playerId}
    className="d-flex flex-column gap-1 align-items-center match-profile-box-container"
  >
    <div className="match-profile-box">
      <img
        className={classNames("circle", {
          "pvt-shadow": !player.photoFile,
        })}
        src={
          player.avatar
            ? player.avatar
            : "/assets/images/empty-avatar.png"
        }
        width={"100%"}
        height={"100%"}
      />
    </div>
    <span
      style={{ maxWidth: "80px" }}
      className={classNames("text-truncate fs-med", { "dark-yellow": true })}
    >
      {player.username}
    </span>
  </Link>
);


export default LiveBattleRecord;
